var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLibrary(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Solid/md-library"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Icon",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.5956 2.55801C12.2267 2.3472 11.7738 2.3472 11.4049 2.55801L3.00486 7.35801C2.42944 7.68682 2.22953 8.41985 2.55834 8.99527C2.7796 9.38248 3.18389 9.59965 3.60002 9.60011V17.9999C2.93728 17.9999 2.40002 18.5372 2.40002 19.1999C2.40002 19.8626 2.93728 20.3999 3.60002 20.3999H20.4C21.0628 20.3999 21.6 19.8626 21.6 19.1999C21.6 18.5372 21.0628 17.9999 20.4 17.9999V9.60011C20.8163 9.59979 21.2208 9.3826 21.4421 8.99527C21.7709 8.41985 21.571 7.68682 20.9956 7.35801L12.5956 2.55801ZM7.20002 10.7999C6.53728 10.7999 6.00002 11.3372 6.00002 11.9999V15.5999C6.00002 16.2626 6.53728 16.7999 7.20002 16.7999C7.86277 16.7999 8.40002 16.2626 8.40002 15.5999V11.9999C8.40002 11.3372 7.86277 10.7999 7.20002 10.7999ZM10.8 11.9999C10.8 11.3372 11.3373 10.7999 12 10.7999C12.6628 10.7999 13.2 11.3372 13.2 11.9999V15.5999C13.2 16.2626 12.6628 16.7999 12 16.7999C11.3373 16.7999 10.8 16.2626 10.8 15.5999V11.9999ZM16.8 10.7999C16.1373 10.7999 15.6 11.3372 15.6 11.9999V15.5999C15.6 16.2626 16.1373 16.7999 16.8 16.7999C17.4628 16.7999 18 16.2626 18 15.5999V11.9999C18 11.3372 17.4628 10.7999 16.8 10.7999Z",
    fill: "#4FC0CF"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLibrary);
export default __webpack_public_path__ + "static/media/library.07cfb21c42a205c1c25831a4727b240e.svg";
export { ForwardRef as ReactComponent };